<template>
  <g>
    <image v-show="!failed" :href="href" @error="onError"></image>
    <svg-badge :x="lx" :y="ly" variant="primary" :scale="scale">${{ annotation.label }}</svg-badge>
  </g>
</template>

<script>
  import { AnnotationResource } from '@/api-resources';
  import SvgBadge from './SvgBadge';

  export default {
    name: 'AnnotationOverlayMask',

    components: {
      SvgBadge,
    },

    props: {
      annotation: AnnotationResource,
      scale: Number,
    },

    data() {
      return {
        failed: false,
      };
    },

    computed: {
      href() {
        return this.annotation.overlayMaskUrl;
      },

      lx() {
        return this.annotation.coordinates.xPositionLabel;
      },

      ly() {
        return this.annotation.coordinates.yPositionLabel;
      },
    },

    methods: {
      onError() {
        this.failed = true;
      },
    },
  };
</script>
